import { Controller } from "@hotwired/stimulus";

// When clicking a candidate row, fills the member combobox with that selection.
export default class extends Controller {
  static values = {
    memberId: String,
    memberLabel: String,
  };

  select(event) {
    event.preventDefault();
    const form = this.element.closest("form");
    if (!form) return;
    const hidden = form.querySelector('input[type="hidden"][name*="import_member_id"]');
    const input = form.querySelector('[data-forms--combobox-target="input"]');
    const id = this.memberIdValue || "";
    const label = this.memberLabelValue || "";

    // 1. Set values first (same as combobox selection)
    if (hidden) hidden.value = id;
    if (input) {
      input.value = label;
      input.dispatchEvent(new Event("input", { bubbles: true }));
    }

    // 2. Dispatch member-selected so bulk-match-preview knows source was suggestion
    form.dispatchEvent(new CustomEvent("member-selected", {
      bubbles: true,
      detail: { source: "suggestion", label, id }
    }));

    // 3. Dispatch change so bulk-match-preview fetches preview and updates Apply mapping (identical to combobox)
    if (hidden) hidden.dispatchEvent(new Event("change", { bubbles: true }));
  }
}
